import { api } from 'services';

export default {
  acceptExchange(orderId) {
    return api.post(`/rent_orders/${orderId}/accept_exchange`);
  },
  rejectExchange(orderId) {
    return api.post(`/rent_orders/${orderId}/reject_exchange`);
  },
  deliverExchange(orderId) {
    return api.post(`/rent_orders/${orderId}/deliver_exchange`);
  },
  resumeRent(orderId) {
    return api.post(`/rent_orders/${orderId}/resume_rent`);
  },
  refundRentExchange(orderId) {
    return api.post(`/rent_orders/${orderId}/refund_rent`);
  },
  exchangeOrder(orderId, data) {
    return api.post(`/exchanges/${orderId}`, data);
  },
};
